import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DataSearchResult } from '../../enums/enums'

@Component({
  selector: 'ddc-search-result-note',
  templateUrl: './ddc-search-result-note.component.html',
  styleUrl: './ddc-search-result-note.component.scss',
  imports: [CommonModule, AngularMaterialsModules],
})
export class DdcSearchResultNoteComponent {
  @Input() result!: DataSearchResult
  @Input() showIcon: boolean = true
  @Input() showTime: boolean = true
  @Output() noteClick = new EventEmitter<DataSearchResult>()

  onNoteClick(): void {
    this.noteClick.emit(this.result)
  }
}
